export default "__VITE_ASSET__Bn36XABV__"